import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { makeInput, Loading } from "common-import/custom";
import { inject, observer } from "mobx-react";
import { TimeHelper, VarHelper } from "common-import/helpers"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Pagination,
  PaginationItem, PaginationLink,
  Row,
  Table
} from "reactstrap";

const StatusList = {
  'all': 'All',
  'WAITING': 'Waiting',
  'COMPLETED': 'Completed',
  'SHIPPED_ORDERS': 'Shipped Orders',
  'ORDER_IN_PROCESS': 'Orders in Process',
  'FAIL_TO_CHARGE': 'Fail to Charge',
  'CANCELED_ORDERS': 'Cancel Orders'
};

@inject("cartOrderStore", "userStore", "routeStore") @observer
export default class OrderList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      page: 1,
      isLoading: true,
      status: 'all',
      list: [],
    };
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getList();
    this.setState({isLoading: false});
  }

  getList = async () => {
    const { status, page } = this.state;
    const { cartOrderStore } = this.props;
    await cartOrderStore.getListStatus(status, page);

    switch (status) {
      case 'all': {
        await cartOrderStore.getAll(page);
        this.setState({list: cartOrderStore.list_ALL});
        break;
      }
      case 'WAITING': {
        this.setState({list: cartOrderStore.list_WAITING});
        break;
      }
      case 'COMPLETED': {
        this.setState({list: cartOrderStore.list_COMPLETED});
        break;
      }
      case 'SHIPPED_ORDERS': {
        this.setState({list: cartOrderStore.list_SHIPPED_ORDERS});
        break;
      }
      case 'ORDER_IN_PROCESS': {
        this.setState({list: cartOrderStore.list_ORDER_IN_PROCESS});
        break;
      }
      case 'FAIL_TO_CHARGE': {
        this.setState({list: cartOrderStore.list_FAIL_TO_CHARGE});
        break;
      }
      case 'CANCELED_ORDERS': {
        this.setState({list: cartOrderStore.list_CANCELED_ORDERS});
        break;
      }
    }
  };

  renderRow = (data = {}, index) => {
    if (!data.shipInfo || !data.billInfo || !data.cart) return null;
    const total = (() =>  {
      let value = 0;
      data.cart.slice().forEach((item, i) => {
        if (!!item.product && !!item.product.price) {
          value = value + item.product.price * item.amount;
        }
      });
      return value;
    })();
    return (
      <tr key={"row"+index}>
        <td>
          <Link to={this.props.routeStore.admin.orderDetail(data.id)}>
            <div><strong>{data.id}</strong></div>
            <div>Total: <b style={{color: 'red'}}>{VarHelper.moneyString(total)}</b></div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div >{data.shipInfo.name}</div>
            <div className="small text-muted">
              <span>Phone</span>: <b>{String(data.shipInfo.phone)}</b>
            </div>
            <div className="small text-muted">
              <span>Email</span>: <b>{String(data.shipInfo.email)}</b>
            </div>
          </div>
        </td>
        <td>
          <a >
            {
              data.cart.map((val, i) => (
                <div className="one-row" key={val.product.name+'i'} style={{maxWidth: 300}}>{val.product.name}</div>
              ))
            }
          </a>
        </td>
        <td>
          <div className="small text-muted">{data.status}</div>
        </td>
        <td>
          <div className="small text-muted">{TimeHelper.toDateString(data.updatedAt)}</div>
        </td>
      </tr>
    )
  };

  render() {
    let { isLoading, list } = this.state;
    list = list.slice();

    if (isLoading) return (<Loading> </Loading>);

    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup>
            <Button type="button" color="primary" onClick={this.search} className="mb-8"><i className="fa fa-search"> </i> Search</Button>
            {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Bidding's name" />)}
          </FormGroup>
        </Form>
        <div className="form">
          <div className="form-group" style={{width:'200px'}}>
            <select value={this.state.status} className="form-control" onChange={(e) => this.setState({status: e.target.value, page: 1}, () => this.getList())}>
              {
                Object.entries(StatusList).map(([key, value]) => {
                  return <option key={key} value={key}>{value}</option>
                })
              }
            </select>
          </div>
        </div>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
              {this.renderTabletTitle()}
              </thead>
              <tbody style={{ backgroundColor: 'white' }}>
              {list.length > 0 && list.map(this.renderRow)}
              </tbody>
            </Table>
            {list.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>{this.messageNotFound}</p>}
          </Col>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev} />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = e => {
    !!e && e.preventDefault();
    const { keyword } = this.state;
    if (keyword == "") {
      this.getList();
    } else {
      this.store.search(keyword, true);
    }
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if (this.state.page === 1) return;
    this.setState({ page: this.state.page - 1 }, () => {
      this.getList();
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    this.setState({ page: this.state.page + 1 }, () => {
      this.getList();
    });
  };

  renderTabletTitle = () => {
    return (
      <tr>
        <th>ID / Money</th>
        <th>Shipping Info</th>
        <th>Cart Info</th>
        <th>Status</th>
        <th>Update At</th>
      </tr>
    );
  };
}




// WEBPACK FOOTER //
// ./src/views/Shop/OrderList.js